
export function WhatsAppButton() {
  const whatsappMessage = encodeURIComponent('Me contacto del sitio web STI, mi nombre es: ');

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3">
      {/* Badge animado a la izquierda — rosa */}
      <div className="whatsapp-animate mb-2 bg-rosa-400 text-white text-xs font-bold px-4 py-2 rounded-full whitespace-nowrap shadow-lg shadow-rosa-400/30 cursor-pointer">
        <a
          href={`https://wa.me/5491140402887?text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white no-underline"
        >
          ¡Chateá con nosotros!
        </a>
      </div>
      
      {/* Botón de WhatsApp con animaciones */}
      <a
        href={`https://wa.me/5491140402887?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-animate w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center transition-all cursor-pointer block flex-shrink-0"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-4xl"></i>
      </a>
    </div>
  );
}
